import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tab, Table, Select, Container, Icon } from "semantic-ui-react";
import * as formatUtils from "../../../../app/util/formatUtils";
import * as textCodeUtils from "../../../../app/util/textCodeUtils";
import { createOptionsCronogramas } from "../../../../app/util/optionsUtils";
import { connect } from "react-redux";
import { getCuotas } from "../../../../app/store/actions/creditoActions";
import { toast } from "react-toastify";
import { MESSAGE_MONTO_COMTEMPLA_PENALIDAD } from "../../../../app/util/messageUtils";

const actions = {
  getCuotas,
};
const mapState = (state) => ({
  credito: state.creditoReducer.credito,
  cuotas: state.creditoReducer.cuotas,
});

const PrestamoDetailInfo = ({ credito, cuotas, getCuotas }) => {
  //Use state
  const [cronogramaSeleccionado, setCronogramaSeleccionado] = useState(
    Math.min(...credito.cronogramas)
  );
  const [activeIndex, setActiveIndex] = useState(0);

  //business rules
  const handleChangeCronograma = (value) => {
    if (value) {
      setCronogramaSeleccionado(value);
      getCuotas({ credito: credito.credito, numeroCronograma: value });
      setActiveIndex(1);
    }
  };
  //handles
  const handleTabChange = (e, { activeIndex }) => setActiveIndex(activeIndex);

  const panes = [
    {
      menuItem: "Detalle",
      render: () => (
        <Tab.Pane>
          <Table basic="very" size="large">
            <Table.Body className="presentacionTable">
              <Table.Row>
                <Table.Cell>Número de Crédito:</Table.Cell>
                <Table.Cell>{credito.credito}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Moneda:</Table.Cell>
                <Table.Cell>
                  {textCodeUtils.getDescripcionMoneda(credito.codigoMoneda)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tasa:</Table.Cell>
                <Table.Cell>
                  {formatUtils.fomartTasa(credito.tasaInteres)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto del préstamo:</Table.Cell>
                <Table.Cell>
                  {`${credito.nombreMoneda} ${formatUtils.formatMoney(
                    credito.importe
                  )}`}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Plazo:</Table.Cell>
                <Table.Cell>{credito.numeroCuotas}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Frecuencia:</Table.Cell>
                <Table.Cell>{credito.frecuencia}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Fecha Desembolso:</Table.Cell>
                <Table.Cell>
                  {formatUtils.dateFormat(credito.fechaDesembolso)}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Sectorista:</Table.Cell>
                <Table.Cell>{credito.sectorista}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Cuotas pendientes",
      render: () => (
        <Tab.Pane>
          {credito.indicadorMulticronograma === true && (
            <Container textAlign="center" style={{ margin: "1.5em" }}>
              <Select
                fluid
                name="numeroCronograma"
                value={cronogramaSeleccionado}
                onChange={(e, data) => {
                  handleChangeCronograma(data.value);
                }}
                placeholder="Selecciona cronograma"
                options={createOptionsCronogramas(credito.cronogramas)}
              />
            </Container>
          )}
          <Table basic="very" size="large">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Nro Cuota</Table.HeaderCell>
                <Table.HeaderCell>Monto</Table.HeaderCell>
                <Table.HeaderCell>Días de atraso</Table.HeaderCell>
                <Table.HeaderCell>Fecha Vencimiento</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {cuotas &&
                cuotas.map((cuota, index) => (
                  <Table.Row key={index} negative={cuota.alertaCuotaVencida === true}>
                    <Table.Cell>{cuota.numero}</Table.Cell>
                    <Table.Cell
                      onClick={() => {
                        if (cuota.alertaCuotaVencida === true)
                          toast.info(MESSAGE_MONTO_COMTEMPLA_PENALIDAD);
                      }}
                      negative={cuota.alertaCuotaVencida === true}
                      style={
                        cuota.alertaCuotaVencida === true ? { cursor: "pointer" } : {}
                      }
                    >
                      {cuota.alertaCuotaVencida === true ? (
                        <>
                          {`${cuota.nombreMoneda} ${formatUtils.formatMoney(
                            cuota.importe
                          )}`}{" "}
                          <Icon name="warning circle" />
                        </>
                      ) : (
                        `${cuota.nombreMoneda} ${formatUtils.formatMoney(
                          cuota.importe
                        )}`
                      )}
                    </Table.Cell>
                    <Table.Cell>{cuota.diasVencidos}</Table.Cell>
                    <Table.Cell>
                      {formatUtils.dateFormat(cuota.fechaVencimiento)}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </Tab.Pane>
      ),
    },
  ];
  return (
    <Tab
      panes={panes}
      activeIndex={activeIndex}
      onTabChange={handleTabChange}
    />
  );
};
PrestamoDetailInfo.propTypes = {
  credito: PropTypes.object.isRequired,
  cuotas: PropTypes.array.isRequired,
  getCuotas: PropTypes.func.isRequired,
};

export default connect(mapState, actions)(PrestamoDetailInfo);
